import { render, staticRenderFns } from "./employeeDetail.vue?vue&type=template&id=5c3ca694&scoped=true&"
import script from "./employeeDetail.vue?vue&type=script&lang=js&"
export * from "./employeeDetail.vue?vue&type=script&lang=js&"
import style0 from "./employeeDetail.vue?vue&type=style&index=0&id=5c3ca694&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3ca694",
  null
  
)

export default component.exports